import * as React from 'react'
const FallBackDefault = ({error}) => {
  return (
    <div role="alert">
      <p>Error</p>
      <pre className="text-danger">{error.message}</pre>
    </div>
  )
}
export default FallBackDefault